import { Record } from 'immutable';
import { IState } from './types';

export const stateFactory = Record<IState>({
  isLoading: true,
  traceId: undefined,
  wizardLoadError: false,
});
